import { computed, effect, inject } from '@angular/core';
import { patchState, signalStoreFeature, withComputed, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { AuthenticationStore } from 'authentication-data';
import { ItemId } from 'products-data';
import { Observable, of } from 'rxjs';
import { EntityRecord, SignalStoreFeatureType } from 'state-data';
import { withCart } from '../..';
import { CartEvent } from '../../data-stores/carts.store';
import { SavedPartListDetailStore } from '../../data-stores/saved-part-list-detail.store';
import { PartListEntityItem, SavedPartListEntity } from '../../types';

export const withSavedPartList = () => {
  return signalStoreFeature(
    withState(() => ({
      listId: undefined as string | undefined,
      _record: undefined as EntityRecord<SavedPartListEntity> | undefined,
    })),
    withComputed((store) => {
      // const cartStore = inject(SavedCartDetailsStore);
      const cartLoading = computed(() => store._record()?.loading ?? true);
      const cartError = computed(() => store._record()?.error ?? null);
      const cart = computed(() => store._record()?.entity ?? null);
      const cartType = computed(() => `list-${cart()?.listType ?? ''}`);
      const cartCustomerNumber = computed(() => cart()?.customerNumber ?? null);
      const cartItems = computed(() => cart()?.items ?? []);
      const cartItemCount = computed(() => cartItems().length);
      const cartNumericId = computed(() => cart()?.id);
      const pendingCartItems = computed(() => []);
      const cartName = computed(() => cart()?.name ?? '');

      return {
        cartLoading,
        cartError,
        cartType,
        cartCustomerNumber,
        cartItems,
        cartItemCount,
        cartNumericId,
        cart,
        pendingCartItems,
        cartName,
      };
    }),
    withProps((store) => {
      const cartStore = inject(SavedPartListDetailStore);
      return {
        cartEvents$: of() as Observable<CartEvent>,
      };
    }),
    withMethods((store) => {
      // const cartStore = inject(CartsStore);

      const isItemPending = (itemId: ItemId) => {
        return false;
      };
      const updateItemQuantity = (itemId: ItemId, quantity: number) => {};

      const clearCart = () => {
        // const id = store.savedCartId();
        // if (id) {
        //   cartStore.clearCart(id);
        // }
      };

      const _selectCartById = (cartId: string) => {
        patchState(store, { listId: cartId });
      };

      const _selectCart = (cartType: string, customerNumber: string) => {
        // patchState(store, { cartId: `${cartType}|${customerNumber}` });
      };

      return {
        clearCart,
        updateItemQuantity,
        isItemPending,
        _selectCartById,
        _selectCart,
      };
    }),
    withHooks((store) => {
      const cartStore = inject(SavedPartListDetailStore);
      const authStore = inject(AuthenticationStore);
      return {
        onInit() {
          effect(() => {
            const isAuthenticated = authStore.isAuthenticated();
            const id = store.listId();
            const cart = id && isAuthenticated ? cartStore.get(id)() : undefined;
            if (!cart) {
              patchState(store, {
                _record: undefined,
              });
            } else {
              patchState(store, {
                _record: {
                  loading: cart.loading,
                  error: cart.error,
                  entity: cart.entity
                    ? {
                        id: cart.entity.id,
                        name: cart.entity.name,
                        createdOn: new Date(cart.entity.created),
                        updatedOn: new Date(cart.entity.modified ?? cart.entity.created),
                        customerNumber: cart.entity.customerNumber ?? '',
                        items: (cart.entity.items ?? []).map((i) => {
                          return {
                            id: ItemId.parse(i.id),
                            quantity: 1,
                          } as PartListEntityItem;
                        }),
                      }
                    : undefined,
                },
              });
            }
          });
        },
      };
    }),
  );
};

export type WithSavedCartFeature = SignalStoreFeatureType<ReturnType<typeof withCart>>;
